export const STRING_TYPE = 'string';
export const NUMBER_TYPE = 'integer';
export const BOOLEAN_TYPE = 'boolean';
export const MARKDOWN_TYPE = 'markdown';
export const HTML_TYPE = 'html';
export const TABLE_TYPE = 'table';
export const LIST_TYPE = 'list';
export const OBJECT_TYPE = 'object';

export const TYPES_CONF_MAP = {
	[STRING_TYPE]: { text: 'String', type: STRING_TYPE },
	[NUMBER_TYPE]: { text: 'Number', type: NUMBER_TYPE },
	[BOOLEAN_TYPE]: { text: 'Boolean', type: BOOLEAN_TYPE },
	[MARKDOWN_TYPE]: { text: 'Markdown', type: STRING_TYPE, format: MARKDOWN_TYPE },
	[HTML_TYPE]: { text: 'HTML', type: STRING_TYPE, format: HTML_TYPE },
	[TABLE_TYPE]: { text: 'Table', type: LIST_TYPE, params: [] },
	[LIST_TYPE]: { text: 'List', type: LIST_TYPE, params: [] },
	[OBJECT_TYPE]: { text: 'List', type: OBJECT_TYPE },
};

export const DATA_TYPES = [
	{ text: 'String', type: 'string', icon: 'data-type-text' },
	{ text: 'Number', type: 'integer', icon: 'data-type-number' },
	{ text: 'Boolean', type: 'boolean', icon: 'data-type-boolean' },
	{ text: 'Markdown', type: 'markdown', icon: 'data-type-markdown' },
	{ text: 'HTML', type: 'html', icon: 'data-type-html' },
	{ text: 'Table', type: 'table', icon: 'action-table-data' },
	{ text: 'List', type: 'list', icon: 'data-type-array' },
	{ text: 'Object', type: 'object', icon: 'data-type-object' },
];
